import { Box, Divider, Typography } from '@mui/material';
import { useStyles } from './ProcedureCodes.styles';
import { btnType, Button } from '../../../../atoms/button';
import LottieOnlineConsult from '../../../../../icons/lotties/lottieIcons/OnlineConsult';
const ProcedureCodes = ({ appointment, onClickAdd, appointmentCptCode, cpts }) => {
  const classes = useStyles();
  const hasCPTcodesAdded = appointmentCptCode?.cptList?.length > 0;

  // Rendering each code with its diagnosis, adding dividers between them
  const renderCodes = () => {
    if (!appointmentCptCode?.cptList || appointmentCptCode.cptList.length === 0) {
      return <Box className={classes.procedureCodes}>No procedure codes added yet</Box>;
    }

    return appointmentCptCode.cptList.map((cpt, index) => {
      const selectedCpt = cpts.find(c => c.code === cpt.cptCode);
      return (
        <Box key={index} display='flex' flexDirection='column' gap='4px'>
          <span className={classes.procedureUuid}>{selectedCpt?.code}</span>
          <span className={classes.procedureServiceName}>{selectedCpt?.cptCode}</span>
          <span className={classes.procedureCodes}>{cpt?.diagnosis}</span>
          {index < appointmentCptCode.cptList.length - 1 && <Divider sx={{ my: '24px', mx: -3 }} />}
        </Box>
      );
    });
  };

  return (
    <Box className={classes.container}>
      <Box className={classes.procedureHeader}>
        <Typography className={classes.procedureHeaderText}>
          Procedure Codes
        </Typography>
        <Button className={classes.procedureFooterBtn} variant={btnType.TEXT} onClick={onClickAdd}>
          {hasCPTcodesAdded ? 'Edit' : 'Add'} CPT Codes
        </Button>
      </Box>
      <Box className={classes.procedureBody}>{renderCodes()}</Box>
    </Box>
  );
};
export { ProcedureCodes };
